import React, { useEffect, useMemo, useRef, useState } from 'react';
import axios from 'axios';
import Dashboard from './Dashboard';
import './FastFoodRecords.css';

const BASE_URL = process.env.REACT_APP_API_URL || 'https://vakra.co.in';
const FASTFOOD_RECORDS_API = `${BASE_URL}/api/fastfood-records`;

const SECTION_TABS = [
  { value: 'bills', label: 'Bills Record', icon: '🧾' },
  { value: 'products', label: 'Product Sales', icon: '📊' },
  { value: 'khata', label: 'Customer Khata', icon: '👤' },
  { value: 'expenses', label: 'Shop Expenses', icon: '💸' },
];

const PAYMENT_STATUS_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'paid', label: 'Paid' },
  { value: 'partial', label: 'Partial' },
  { value: 'unpaid', label: 'Credit / Udhari' },
  { value: 'due', label: 'Due Pending' },
  { value: 'cod', label: 'COD' },
];

const PAYMENT_METHOD_OPTIONS = [
  { value: 'all', label: 'All Methods' },
  { value: 'cash', label: 'Cash' },
  { value: 'upi', label: 'UPI' },
  { value: 'card', label: 'Card' },
  { value: 'online', label: 'Online' },
  { value: 'razorpay', label: 'Razorpay' },
  { value: 'credit', label: 'Credit' },
  { value: 'cod', label: 'COD' },
];

const ORDER_MODE_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'dine_in', label: 'Dine In' },
  { value: 'takeaway', label: 'Takeaway' },
  { value: 'delivery', label: 'Delivery' },
];

const DATE_OPTIONS = [
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: '7days', label: 'Last 7 Days' },
  { value: 'month', label: 'This Month' },
  { value: 'custom', label: 'Custom' },
];

const EXPENSE_CATEGORY_OPTIONS = [
  { value: 'all', label: 'All Expenses', icon: '💸' },
  { value: 'raw_material', label: 'Raw Material', icon: '📦' },
  { value: 'staff_payment', label: 'Staff Payment', icon: '👨‍🍳' },
  { value: 'supplier_payment', label: 'Supplier Payment', icon: '🚚' },
  { value: 'rent', label: 'Rent', icon: '🏪' },
  { value: 'electricity', label: 'Electricity', icon: '💡' },
  { value: 'gas_cylinder', label: 'Gas Cylinder', icon: '🔥' },
  { value: 'packaging', label: 'Packaging', icon: '🥡' },
  { value: 'repair_maintenance', label: 'Repair / Maintenance', icon: '🛠️' },
  { value: 'transport', label: 'Transport', icon: '🚛' },
  { value: 'delivery_boy_payment', label: 'Delivery Boy Payment', icon: '🛵' },
  { value: 'software_charge', label: 'Software Charge', icon: '💻' },
  { value: 'other', label: 'Other', icon: '🧾' },
];

const EXPENSE_PAYMENT_STATUS_OPTIONS = [
  { value: 'all', label: 'All Status' },
  { value: 'paid', label: 'Paid' },
  { value: 'partial', label: 'Partial' },
  { value: 'unpaid', label: 'Due / Unpaid' },
];

const EXPENSE_PAYMENT_METHOD_OPTIONS = [
  { value: 'cash', label: 'Cash' },
  { value: 'upi', label: 'UPI' },
  { value: 'card', label: 'Card' },
  { value: 'bank', label: 'Bank' },
  { value: 'online', label: 'Online' },
  { value: 'credit', label: 'Credit' },
  { value: 'other', label: 'Other' },
];

const emptySummary = {
  totalOrders: 0,
  totalSales: 0,
  paidAmount: 0,
  dueAmount: 0,
  avgOrderValue: 0,
  todayOrders: 0,
  productQty: 0,
  productSalesValue: 0,
  dueCustomers: 0,
  totalExpense: 0,
  expensePaid: 0,
  expenseDue: 0,
};

const FastFoodRecords = () => {
  const [vendorId, setVendorId] = useState(null);
  const [vendorType, setVendorType] = useState('fastfood');

  const [orders, setOrders] = useState([]);
  const [serverProductSales, setServerProductSales] = useState([]);

  const [expenses, setExpenses] = useState([]);
  const [expenseSummary, setExpenseSummary] = useState({
    totalExpense: 0,
    total_expense: 0,
    expensePaid: 0,
    expense_paid: 0,
    expenseDue: 0,
    expense_due: 0,
    todayExpense: 0,
    today_expense: 0,
    expenseCount: 0,
    expense_count: 0,
    categorySummary: [],
    category_summary: [],
  });

  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [selectedCustomerKey, setSelectedCustomerKey] = useState('');

  const [activeSection, setActiveSection] = useState('bills');
  const [loading, setLoading] = useState(true);
  const [savingPayment, setSavingPayment] = useState(false);

  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('success');

  const [search, setSearch] = useState('');
  const [paymentStatus, setPaymentStatus] = useState('all');
  const [paymentMethod, setPaymentMethod] = useState('all');
  const [orderMode, setOrderMode] = useState('all');

  const [expenseCategory, setExpenseCategory] = useState('all');
  const [expenseStatus, setExpenseStatus] = useState('all');
  const [expenseSaving, setExpenseSaving] = useState(false);
  const [selectedExpenseId, setSelectedExpenseId] = useState(null);

  const [datePreset, setDatePreset] = useState('today');
  const [customFrom, setCustomFrom] = useState('');
  const [customTo, setCustomTo] = useState('');

  const [billModalOpen, setBillModalOpen] = useState(false);

  const billsRef = useRef(null);
  const productsRef = useRef(null);
  const khataRef = useRef(null);
  const expensesRef = useRef(null);

  const [paymentBox, setPaymentBox] = useState({
    open: false,
    type: 'partial',
    customer: null,
    bill: null,
    amount: '',
    method: 'cash',
    note: '',
    referenceNo: '',
  });

  /*
    localPayments अब सिर्फ temporary optimistic view के लिए है.
    Main save backend API se hoga aur refresh ke baad DB se amount आएगा.
  */
  const [localPayments, setLocalPayments] = useState([]);

  const [expenseForm, setExpenseForm] = useState({
    id: null,
    expenseDate: '',
    expenseCategory: 'raw_material',
    expenseTitle: '',
    paidToName: '',
    paidToMobile: '',
    totalAmount: '',
    amountPaid: '',
    paymentMethod: 'cash',
    referenceNo: '',
    note: '',
    billImage: '',
    receiptFile: null,
    receiptPreview: '',
  });

  const [expensePaymentBox, setExpensePaymentBox] = useState({
    open: false,
    expense: null,
    amount: '',
    method: 'cash',
    referenceNo: '',
    note: '',
  });

  const getToken = () => localStorage.getItem('token') || '';

  const showMessage = (text, type = 'success') => {
    setMessage(text);
    setMessageType(type);

    window.clearTimeout(showMessage._timer);
    showMessage._timer = window.setTimeout(() => {
      setMessage('');
    }, 3200);
  };

  const toNumber = (value, fallback = 0) => {
    const num = Number(value);
    return Number.isFinite(num) ? num : fallback;
  };

  const formatMoney = (value) =>
    `₹${Number(value || 0).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;

  const formatShortMoney = (value) =>
    `₹${Number(value || 0).toLocaleString('en-IN', {
      maximumFractionDigits: 0,
    })}`;

  const getTodayInputDate = () => formatDateInput(new Date());

  const getExpenseCategoryOption = (value) => {
    return (
      EXPENSE_CATEGORY_OPTIONS.find((item) => item.value === String(value || '').trim()) ||
      EXPENSE_CATEGORY_OPTIONS.find((item) => item.value === 'other')
    );
  };

  const getExpenseCategoryLabel = (value) => getExpenseCategoryOption(value)?.label || 'Other';

  const getExpenseCategoryIcon = (value) => getExpenseCategoryOption(value)?.icon || '🧾';

  const getExpensePaymentStatusLabel = (status) => {
    if (status === 'paid') return 'Paid';
    if (status === 'partial') return 'Partial';
    return 'Due / Unpaid';
  };

  const getExpensePaymentStatus = (expense) => {
    return String(expense?.paymentStatus || expense?.payment_status || 'unpaid').toLowerCase();
  };

  const getExpenseDueAmount = (expense) => {
    return toNumber(expense?.dueAmount ?? expense?.due_amount, 0);
  };

  const getExpensePaidAmount = (expense) => {
    return toNumber(expense?.amountPaid ?? expense?.amount_paid, 0);
  };

  const getExpenseTotalAmount = (expense) => {
    return toNumber(expense?.totalAmount ?? expense?.total_amount, 0);
  };

  const getExpenseReceiptUrl = (expense) => {
    const raw = String(
      expense?.billImage ||
        expense?.bill_image ||
        expense?.receiptUrl ||
        expense?.receipt_url ||
        ''
    ).trim();

    if (!raw) return '';
    if (/^(https?:|data:|blob:)/i.test(raw)) return raw;

    const normalized = raw.startsWith('/') ? raw : `/${raw}`;
    return `${BASE_URL}${normalized}`;
  };

  const resetExpenseForm = () => {
    setExpenseForm({
      id: null,
      expenseDate: getTodayInputDate(),
      expenseCategory: 'raw_material',
      expenseTitle: '',
      paidToName: '',
      paidToMobile: '',
      totalAmount: '',
      amountPaid: '',
      paymentMethod: 'cash',
      referenceNo: '',
      note: '',
      billImage: '',
      receiptFile: null,
      receiptPreview: '',
    });
  };

  const formatDateInput = (value) => {
    if (!value) return '';

    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

  const formatDateTime = (value) => {
    if (!value) return '-';

    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return String(value);

    return d.toLocaleString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const formatDateOnly = (value) => {
    if (!value) return '-';

    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return String(value);

    return d.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  const safeJsonParse = (value, fallback = []) => {
    try {
      if (!value) return fallback;
      if (Array.isArray(value)) return value;
      if (typeof value === 'object') return value;
      return JSON.parse(value);
    } catch {
      return fallback;
    }
  };

  const getDbQueryParam = () => {
    const type = String(vendorType || 'fastfood').toLowerCase();

    if (type === 'cosmetic') return 'cods=true';
    if (type === 'garments' || type === 'garment') return 'grdb=true';

    return 'userdb=true';
  };

  const normalizeOrderMode = (order) => {
    const raw = String(order?.order_mode || order?.orderMode || order?.displayMode || '').toLowerCase();

    if (raw === 'delivery') return 'delivery';
    if (raw === 'takeaway' || raw === 'pickup') return 'takeaway';
    if (raw === 'dine_in' || raw === 'dine-in') return 'dine_in';

    return order?.table_number ? 'dine_in' : 'takeaway';
  };

  const normalizePaymentStatus = (order) => {
    const rawStatus = String(
      order?.payment_status ||
        order?.paymentStatus ||
        order?.displayPaymentStatus ||
        ''
    ).toLowerCase();

    const rawMethod = String(
      order?.payment_method ||
        order?.paymentMethod ||
        order?.displayPaymentMethod ||
        ''
    ).toLowerCase();

    if (rawStatus === 'paid') return 'paid';
    if (rawStatus === 'partial') return 'partial';
    if (rawStatus === 'cod') return 'cod';
    if (rawStatus === 'credit') return 'unpaid';
    if (rawStatus === 'unpaid') return 'unpaid';

    if (rawMethod === 'cod') return 'cod';

    return 'unpaid';
  };

  const normalizePaymentMethod = (order, status) => {
    const raw = String(
      order?.payment_method ||
        order?.paymentMethod ||
        order?.displayPaymentMethod ||
        ''
    ).toLowerCase();

    if (status === 'cod') return 'cod';
    if (status === 'unpaid') return raw || 'credit';

    return raw || 'cash';
  };

  const getProductsTotal = (products = []) => {
    return products.reduce((sum, item) => {
      const qty = toNumber(item?.quantity || item?.qty, 1);
      const rate = toNumber(item?.price ?? item?.selling_price ?? item?.rate, 0);
      const lineTotal = toNumber(item?.line_total ?? item?.total, qty * rate);

      return sum + lineTotal;
    }, 0);
  };

  const getFullAddress = (order) => {
    return [
      order?.address_line1,
      order?.address_line2,
      order?.landmark,
      order?.city,
      order?.state,
      order?.pincode,
    ]
      .filter(Boolean)
      .join(', ');
  };

  const getOrderRecordDate = (order) => {
    return (
      order?.record_date ||
      order?.completed_at ||
      order?.invoice_saved_at ||
      order?.updated_at ||
      order?.created_at ||
      order?.paid_at
    );
  };

  const getCustomerName = (order) => {
    const possible =
      order?.customer_name ||
      order?.customerName ||
      order?.delivery_customer_name ||
      order?.delivery_details?.customer_name ||
      order?.name ||
      '';

    const text = String(possible || '').trim();

    if (!text || text.toLowerCase() === 'null' || text.toLowerCase() === 'undefined') {
      return 'Walk-in Customer';
    }

    return text;
  };

  const getCustomerMobile = (order) => {
    return String(
      order?.customer_mobile ||
        order?.customerMobile ||
        order?.delivery_customer_mobile ||
        order?.customer_number ||
        order?.delivery_details?.customer_mobile ||
        ''
    ).trim();
  };

  const normalizeOrder = (order) => {
    const products = safeJsonParse(order?.productsParsed || order?.products, []);
    const paymentStatusValue = normalizePaymentStatus(order);
    const paymentMethodValue = normalizePaymentMethod(order, paymentStatusValue);

    const productTotal = getProductsTotal(products);

    const finalTotal = toNumber(
      order?.final_total ??
        order?.bill_total ??
        order?.display_total ??
        order?.total_price ??
        productTotal,
      productTotal
    );

    let amountPaid = toNumber(
      order?.amount_paid ??
        order?.paid_amount ??
        order?.received_amount ??
        order?.total_paid,
      0
    );

    const dueAmountFromServer = toNumber(
      order?.due_amount ?? order?.balance_due,
      Math.max(0, finalTotal - amountPaid)
    );

    if (paymentStatusValue === 'paid') {
      amountPaid = finalTotal;
    }

    const dueAmount =
      paymentStatusValue === 'paid'
        ? 0
        : Math.max(0, dueAmountFromServer);

    const id = order?.id || order?.bill_id || order?.order_id;
    const orderId = order?.order_id || order?.real_order_id || order?.orderId || id;

    return {
      ...order,
      id,
      billId: order?.bill_id || id,
      bill_id: order?.bill_id || id,
      orderId,
      order_id: orderId,
      orderNo: order?.order_no || order?.orderNo || `ORD-${String(orderId || '').padStart(5, '0')}`,
      billNo:
        order?.bill_no ||
        order?.invoice_no ||
        order?.billNo ||
        order?.bill?.bill_no ||
        `BILL-${String(id || '').padStart(5, '0')}`,
      productsParsed: products,
      recordDate: getOrderRecordDate(order),
      displayMode: normalizeOrderMode(order),
      displayPaymentStatus: paymentStatusValue,
      displayPaymentMethod: paymentMethodValue,
      customerName: getCustomerName(order),
      customerMobile: getCustomerMobile(order),
      fullAddress: order?.full_address || getFullAddress(order),
      finalTotal,
      amountPaid,
      dueAmount,
      itemCount: products.reduce((sum, item) => sum + toNumber(item?.quantity || item?.qty, 1), 0),
      status: String(order?.status || order?.order_status || '').toLowerCase(),
    };
  };

  const fetchVendorDetails = async () => {
    const token = getToken();

    if (!token) {
      setLoading(false);
      showMessage('Please login to view records.', 'error');
      return;
    }

    try {
      const res = await axios.get(`${FASTFOOD_RECORDS_API}/get-vendor-id`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const nextVendorId = res?.data?.vendorId || res?.data?.vendor_id || null;
      const nextVendorType = String(res?.data?.vendorType || 'fastfood').toLowerCase();

      setVendorId(nextVendorId);
      setVendorType(nextVendorType || 'fastfood');
    } catch (err) {
      setLoading(false);
      showMessage(
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          'Vendor details could not be loaded.',
        'error'
      );
    }
  };

  const fetchRecords = async () => {
    const token = getToken();

    if (!token || !vendorId) return;

    try {
      setLoading(true);
      setMessage('');

      const queryParam = getDbQueryParam();

      const res = await axios.get(`${FASTFOOD_RECORDS_API}/history?${queryParam}&_=${Date.now()}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
        },
      });

      const rawOrders = Array.isArray(res?.data?.orders) ? res.data.orders : [];
      const apiProductSales = Array.isArray(res?.data?.productSales) ? res.data.productSales : [];

      const normalized = rawOrders
        .map(normalizeOrder)
        .filter((order) => Number(order.vendor_id || vendorId) === Number(vendorId))
        .sort((a, b) => new Date(b.recordDate || 0) - new Date(a.recordDate || 0));

      setOrders(normalized);
      setServerProductSales(apiProductSales);

      setSelectedOrderId((prev) => {
        if (prev && normalized.some((order) => Number(order.id) === Number(prev))) return prev;
        return normalized[0]?.id || null;
      });

      if (!normalized.length) {
        showMessage('No records found.', 'error');
      }
    } catch (err) {
      showMessage(
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          'Records could not be loaded.',
        'error'
      );
    } finally {
      setLoading(false);
    }
  };

  const fetchExpenses = async () => {
    const token = getToken();

    if (!token || !vendorId) return;

    try {
      const params = new URLSearchParams();
      params.set('datePreset', datePreset);
      params.set('category', expenseCategory);
      params.set('paymentStatus', expenseStatus);

      if (datePreset === 'custom') {
        if (customFrom) params.set('from', customFrom);
        if (customTo) params.set('to', customTo);
      }

      params.set('_', String(Date.now()));

      const res = await axios.get(`${FASTFOOD_RECORDS_API}/expenses?${params.toString()}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
        },
      });

      const nextExpenses = Array.isArray(res?.data?.expenses) ? res.data.expenses : [];
      const nextSummary = res?.data?.expenseSummary || res?.data?.expense_summary || {};

      setExpenses(nextExpenses);
      setExpenseSummary((prev) => ({ ...prev, ...nextSummary }));
      setSelectedExpenseId((prev) => {
        if (prev && nextExpenses.some((item) => Number(item.id || item.expenseId) === Number(prev))) {
          return prev;
        }

        return nextExpenses[0]?.id || nextExpenses[0]?.expenseId || null;
      });
    } catch (err) {
      showMessage(
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          'Expenses could not be loaded.',
        'error'
      );
    }
  };

  const refreshAllRecords = async () => {
    await fetchRecords();
    await fetchExpenses();
  };

  useEffect(() => {
    fetchVendorDetails();
  }, []);

  useEffect(() => {
    if (vendorId) {
      fetchRecords();
    }
  }, [vendorId, vendorType]);

  useEffect(() => {
    setExpenseForm((prev) => ({
      ...prev,
      expenseDate: prev.expenseDate || getTodayInputDate(),
    }));
  }, []);

  const dateRange = useMemo(() => {
    const today = new Date();
    const todayText = formatDateInput(today);

    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const last7 = new Date(today);
    last7.setDate(today.getDate() - 6);

    const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);

    if (datePreset === 'today') {
      return { from: todayText, to: todayText, label: 'Today' };
    }

    if (datePreset === 'yesterday') {
      const y = formatDateInput(yesterday);
      return { from: y, to: y, label: 'Yesterday' };
    }

    if (datePreset === '7days') {
      return {
        from: formatDateInput(last7),
        to: todayText,
        label: 'Last 7 Days',
      };
    }

    if (datePreset === 'month') {
      return {
        from: formatDateInput(monthStart),
        to: todayText,
        label: 'This Month',
      };
    }

    return {
      from: customFrom,
      to: customTo,
      label:
        customFrom && customTo
          ? `${formatDateOnly(customFrom)} - ${formatDateOnly(customTo)}`
          : 'Custom Range',
    };
  }, [datePreset, customFrom, customTo]);

  useEffect(() => {
    if (vendorId) {
      fetchExpenses();
    }
  }, [vendorId, datePreset, customFrom, customTo, expenseCategory, expenseStatus]);

  const filteredOrders = useMemo(() => {
    const q = search.trim().toLowerCase();

    return orders.filter((order) => {
      const orderDate = formatDateInput(order.recordDate || order.created_at);

      const dateOk =
        (!dateRange.from || orderDate >= dateRange.from) &&
        (!dateRange.to || orderDate <= dateRange.to);

      const statusOk =
        paymentStatus === 'all' ||
        order.displayPaymentStatus === paymentStatus ||
        (paymentStatus === 'due' && toNumber(order.dueAmount) > 0);

      const methodOk =
        paymentMethod === 'all' || order.displayPaymentMethod === paymentMethod;

      const modeOk = orderMode === 'all' || order.displayMode === orderMode;

      const text = [
        order.id,
        order.orderNo,
        order.billNo,
        order.customerName,
        order.customerMobile,
        order.table_number,
        order.fullAddress,
        order.displayPaymentStatus,
        order.displayPaymentMethod,
        ...(order.productsParsed || []).map((item) => item?.name || item?.item_name || item?.product_name),
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();

      const searchOk = !q || text.includes(q);

      return dateOk && statusOk && methodOk && modeOk && searchOk;
    });
  }, [orders, search, paymentStatus, paymentMethod, orderMode, dateRange]);

  const selectedOrder = useMemo(() => {
    return (
      filteredOrders.find((order) => Number(order.id) === Number(selectedOrderId)) ||
      filteredOrders[0] ||
      null
    );
  }, [filteredOrders, selectedOrderId]);

  const summary = useMemo(() => {
    if (!filteredOrders.length) return emptySummary;

    const totalOrders = filteredOrders.length;
    const totalSales = filteredOrders.reduce((sum, order) => sum + toNumber(order.finalTotal), 0);
    const paidAmount = filteredOrders.reduce((sum, order) => sum + toNumber(order.amountPaid), 0);
    const dueAmount = filteredOrders.reduce((sum, order) => sum + toNumber(order.dueAmount), 0);
    const productQty = filteredOrders.reduce((sum, order) => sum + toNumber(order.itemCount), 0);

    const customerDueMap = new Map();

    filteredOrders.forEach((order) => {
      if (toNumber(order.dueAmount) <= 0) return;
      const key = order.customerMobile || order.customerName || order.id;
      customerDueMap.set(key, true);
    });

    const todayText = formatDateInput(new Date());
    const todayOrders = filteredOrders.filter(
      (order) => formatDateInput(order.recordDate || order.created_at) === todayText
    ).length;

    return {
      totalOrders,
      totalSales,
      paidAmount,
      dueAmount,
      avgOrderValue: totalOrders > 0 ? totalSales / totalOrders : 0,
      todayOrders,
      productQty,
      productSalesValue: totalSales,
      dueCustomers: customerDueMap.size,
    };
  }, [filteredOrders]);

  const totalExpense = toNumber(
    expenseSummary.totalExpense ?? expenseSummary.total_expense,
    expenses.reduce((sum, item) => sum + getExpenseTotalAmount(item), 0)
  );

  const expensePaid = toNumber(
    expenseSummary.expensePaid ?? expenseSummary.expense_paid,
    expenses.reduce((sum, item) => sum + getExpensePaidAmount(item), 0)
  );

  const expenseDue = toNumber(
    expenseSummary.expenseDue ?? expenseSummary.expense_due,
    expenses.reduce((sum, item) => sum + getExpenseDueAmount(item), 0)
  );

  const filteredExpenses = useMemo(() => {
    const q = search.trim().toLowerCase();

    return expenses.filter((expense) => {
      if (expenseCategory !== 'all') {
        const category = expense.expenseCategory || expense.expense_category;
        if (category !== expenseCategory) return false;
      }

      if (expenseStatus !== 'all') {
        if (getExpensePaymentStatus(expense) !== expenseStatus) return false;
      }

      if (!q) return true;

      const text = [
        expense.id,
        expense.expenseTitle,
        expense.expense_title,
        expense.expenseCategory,
        expense.expense_category,
        getExpenseCategoryLabel(expense.expenseCategory || expense.expense_category),
        expense.paidToName,
        expense.paid_to_name,
        expense.paidToMobile,
        expense.paid_to_mobile,
        expense.paymentMethod,
        expense.payment_method,
        expense.referenceNo,
        expense.reference_no,
        expense.note,
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();

      return text.includes(q);
    });
  }, [expenses, search, expenseCategory, expenseStatus]);

  const selectedExpense = useMemo(() => {
    return (
      filteredExpenses.find((expense) => Number(expense.id || expense.expenseId) === Number(selectedExpenseId)) ||
      filteredExpenses[0] ||
      null
    );
  }, [filteredExpenses, selectedExpenseId]);

  const computedProductSales = useMemo(() => {
    const map = new Map();

    filteredOrders.forEach((order) => {
      (order.productsParsed || []).forEach((item) => {
        const name = String(item?.name || item?.item_name || item?.product_name || 'Item').trim();
        const key = name.toLowerCase();

        const qty = toNumber(item?.quantity || item?.qty, 1);
        const rate = toNumber(item?.price ?? item?.selling_price ?? item?.rate, 0);
        const total = toNumber(item?.line_total ?? item?.total, qty * rate);

        if (!map.has(key)) {
          map.set(key, {
            name,
            product_name: name,
            qty: 0,
            quantity_sold: 0,
            sales: 0,
            total_sales: 0,
            orderCount: 0,
            order_count: 0,
            orders: new Set(),
          });
        }

        const row = map.get(key);

        row.qty += qty;
        row.quantity_sold += qty;
        row.sales += total;
        row.total_sales += total;
        row.orders.add(order.id);
      });
    });

    return Array.from(map.values())
      .map((item) => ({
        ...item,
        orderCount: item.orders.size,
        order_count: item.orders.size,
        percent: summary.totalSales > 0 ? (item.sales / summary.totalSales) * 100 : 0,
        percentage: summary.totalSales > 0 ? (item.sales / summary.totalSales) * 100 : 0,
      }))
      .sort((a, b) => b.sales - a.sales);
  }, [filteredOrders, summary.totalSales]);

  const productSales = useMemo(() => {
    if (!serverProductSales.length) return computedProductSales;

    const normalized = serverProductSales.map((item) => ({
      ...item,
      name: item.name || item.product_name || 'Item',
      product_name: item.product_name || item.name || 'Item',
      qty: toNumber(item.qty ?? item.quantity_sold, 0),
      quantity_sold: toNumber(item.quantity_sold ?? item.qty, 0),
      sales: toNumber(item.sales ?? item.total_sales, 0),
      total_sales: toNumber(item.total_sales ?? item.sales, 0),
      orderCount: toNumber(item.orderCount ?? item.order_count, 0),
      order_count: toNumber(item.order_count ?? item.orderCount, 0),
      percent: toNumber(item.percent ?? item.percentage, 0),
      percentage: toNumber(item.percentage ?? item.percent, 0),
    }));

    const q = search.trim().toLowerCase();

    return normalized
      .filter((item) => {
        if (!q) return true;
        return String(item.name || item.product_name || '').toLowerCase().includes(q);
      })
      .sort((a, b) => b.sales - a.sales);
  }, [serverProductSales, computedProductSales, search]);

  const customerRecords = useMemo(() => {
    const map = new Map();

    filteredOrders.forEach((order) => {
      const mobile = String(order.customerMobile || '').trim();
      const name = String(order.customerName || 'Customer').trim();
      const key = mobile || name.toLowerCase() || `order_${order.id}`;

      if (!map.has(key)) {
        map.set(key, {
          customerKey: key,
          customerName: name,
          customer_name: name,
          customerMobile: mobile,
          customer_mobile: mobile,
          totalPurchase: 0,
          total_purchase: 0,
          totalPaid: 0,
          total_paid: 0,
          dueAmount: 0,
          due_amount: 0,
          totalOrders: 0,
          total_orders: 0,
          paidBills: 0,
          partialBills: 0,
          unpaidBills: 0,
          lastOrderDate: order.recordDate || order.created_at,
          last_order_date: order.recordDate || order.created_at,
          bills: [],
          localPayments: [],
        });
      }

      const row = map.get(key);

      const originalTotal = toNumber(order.finalTotal);
      const originalPaid = toNumber(order.amountPaid);
      const originalDue = toNumber(order.dueAmount);

      row.totalPurchase += originalTotal;
      row.total_purchase += originalTotal;

      row.totalPaid += originalPaid;
      row.total_paid += originalPaid;

      row.dueAmount += originalDue;
      row.due_amount += originalDue;

      row.totalOrders += 1;
      row.total_orders += 1;

      if (order.displayPaymentStatus === 'paid' || originalDue <= 0) {
        row.paidBills += 1;
      } else if (order.displayPaymentStatus === 'partial') {
        row.partialBills += 1;
      } else {
        row.unpaidBills += 1;
      }

      row.bills.push(order);

      if (new Date(order.recordDate || 0) > new Date(row.lastOrderDate || 0)) {
        row.lastOrderDate = order.recordDate || order.created_at;
        row.last_order_date = order.recordDate || order.created_at;
      }
    });

    localPayments.forEach((payment) => {
      const key = payment.customerKey || payment.customerMobile || payment.customerName;

      if (!key || !map.has(key)) return;

      const row = map.get(key);
      row.localPayments.push(payment);
    });

    return Array.from(map.values())
      .map((customer) => {
        const paidFromLocal = customer.localPayments.reduce(
          (sum, item) => sum + toNumber(item.amount),
          0
        );

        const nextPaid = customer.totalPaid + paidFromLocal;
        const nextDue = Math.max(0, customer.dueAmount - paidFromLocal);

        return {
          ...customer,
          totalPaid: nextPaid,
          total_paid: nextPaid,
          dueAmount: nextDue,
          due_amount: nextDue,
          paidFromLocal,
        };
      })
      .sort((a, b) => b.dueAmount - a.dueAmount);
  }, [filteredOrders, localPayments]);

  const dueCustomers = useMemo(() => {
    return customerRecords.filter((customer) => toNumber(customer.dueAmount) > 0);
  }, [customerRecords]);

  const selectedCustomer = useMemo(() => {
    const list = activeSection === 'khata' ? customerRecords : dueCustomers;

    if (!list.length) return null;

    if (selectedCustomerKey) {
      const found = list.find((customer) => {
        const key =
          customer.customerKey ||
          customer.customerMobile ||
          customer.customer_mobile ||
          customer.customerName ||
          customer.customer_name;

        return String(key) === String(selectedCustomerKey);
      });

      if (found) return found;
    }

    return list[0];
  }, [customerRecords, dueCustomers, selectedCustomerKey, activeSection]);

  const getBillLocalPaid = (bill) => {
    if (!bill?.id) return 0;

    return localPayments
      .filter((payment) => String(payment.billId || '') === String(bill.id))
      .reduce((sum, payment) => sum + toNumber(payment.amount), 0);
  };

  const getBillRemainingDue = (bill) => {
    const originalDue = toNumber(bill?.dueAmount, 0);
    const localPaid = getBillLocalPaid(bill);

    return Math.max(0, originalDue - localPaid);
  };

  const getBillAdjustedPaid = (bill) => {
    return toNumber(bill?.amountPaid, 0) + getBillLocalPaid(bill);
  };

  const getBillAdjustedStatus = (bill) => {
    const remainingDue = getBillRemainingDue(bill);

    if (remainingDue <= 0) return 'paid';
    if (getBillAdjustedPaid(bill) > 0) return 'partial';

    return bill?.displayPaymentStatus || 'unpaid';
  };

  const getCustomerPayableDue = (customer) => {
    if (!customer) return 0;

    return Math.max(0, toNumber(customer.dueAmount, 0));
  };

  const getPaymentStatusLabel = (status) => {
    if (status === 'paid') return 'Paid';
    if (status === 'partial') return 'Partial';
    if (status === 'cod') return 'COD';
    return 'Credit / Udhari';
  };

  const getModeLabel = (mode) => {
    if (mode === 'dine_in') return 'Dine In';
    if (mode === 'delivery') return 'Delivery';
    return 'Takeaway';
  };

  const scrollToSection = (ref) => {
    setTimeout(() => {
      if (ref?.current) {
        ref.current.scrollIntoView({
          behavior: 'auto',
          block: 'start',
        });
      }
    }, 0);
  };

  const openBillsSection = (nextStatus = 'all') => {
    setActiveSection('bills');
    setPaymentStatus(nextStatus);
    scrollToSection(billsRef);
  };

  const openProductsSection = () => {
    setActiveSection('products');
    setPaymentStatus('all');
    scrollToSection(productsRef);
  };

  const openKhataSection = () => {
    setActiveSection('khata');
    setPaymentStatus('all');
    scrollToSection(khataRef);
  };

  const openExpensesSection = () => {
    setActiveSection('expenses');
    scrollToSection(expensesRef);
  };

  const handleExpenseInputChange = (field, value) => {
    setExpenseForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleExpenseReceiptChange = (file) => {
    if (!file) {
      setExpenseForm((prev) => ({
        ...prev,
        receiptFile: null,
        receiptPreview: prev.billImage ? getExpenseReceiptUrl({ billImage: prev.billImage }) : '',
      }));
      return;
    }

    if (!file.type || !file.type.startsWith('image/')) {
      showMessage('Please upload an image file only.', 'error');
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      showMessage('Receipt image size must be under 5 MB.', 'error');
      return;
    }

    setExpenseForm((prev) => ({
      ...prev,
      receiptFile: file,
      receiptPreview: URL.createObjectURL(file),
    }));
  };

  const editExpense = (expense) => {
    setActiveSection('expenses');
    setSelectedExpenseId(expense.id || expense.expenseId);
    setExpenseForm({
      id: expense.id || expense.expenseId || null,
      expenseDate: formatDateInput(expense.expenseDate || expense.expense_date || new Date()),
      expenseCategory: expense.expenseCategory || expense.expense_category || 'other',
      expenseTitle: expense.expenseTitle || expense.expense_title || '',
      paidToName: expense.paidToName || expense.paid_to_name || '',
      paidToMobile: expense.paidToMobile || expense.paid_to_mobile || '',
      totalAmount: String(getExpenseTotalAmount(expense) || ''),
      amountPaid: String(getExpensePaidAmount(expense) || ''),
      paymentMethod: expense.paymentMethod || expense.payment_method || 'cash',
      referenceNo: expense.referenceNo || expense.reference_no || '',
      note: expense.note || '',
      billImage: expense.billImage || expense.bill_image || '',
      receiptFile: null,
      receiptPreview: getExpenseReceiptUrl(expense),
    });
    scrollToSection(expensesRef);
  };

  const submitExpense = async () => {
    if (expenseSaving) return;

    const token = getToken();
    if (!token) {
      showMessage('Login token is missing. Please login again.', 'error');
      return;
    }

    const totalAmount = toNumber(expenseForm.totalAmount, 0);
    const amountPaid = toNumber(expenseForm.amountPaid, 0);

    if (!expenseForm.expenseDate) {
      showMessage('Please select an expense date.', 'error');
      return;
    }

    if (!String(expenseForm.expenseTitle || '').trim()) {
      showMessage('Expense title is required.', 'error');
      return;
    }

    if (totalAmount <= 0) {
      showMessage('Please enter a valid expense amount.', 'error');
      return;
    }

    if (amountPaid < 0 || amountPaid > totalAmount) {
      showMessage('Paid amount cannot be greater than total amount.', 'error');
      return;
    }

    const payload = new FormData();
    payload.append('expenseDate', expenseForm.expenseDate);
    payload.append('expenseCategory', expenseForm.expenseCategory);
    payload.append('expenseTitle', expenseForm.expenseTitle);
    payload.append('paidToName', expenseForm.paidToName || '');
    payload.append('paidToMobile', expenseForm.paidToMobile || '');
    payload.append('totalAmount', String(totalAmount));
    payload.append('amountPaid', String(amountPaid));
    payload.append('paymentMethod', expenseForm.paymentMethod || 'cash');
    payload.append('referenceNo', expenseForm.referenceNo || '');
    payload.append('note', expenseForm.note || '');
    payload.append('billImage', expenseForm.billImage || '');

    if (expenseForm.receiptFile) {
      payload.append('receipt', expenseForm.receiptFile);
    }

    try {
      setExpenseSaving(true);

      const isEdit = Boolean(expenseForm.id);
      const url = isEdit
        ? `${FASTFOOD_RECORDS_API}/expenses/${expenseForm.id}`
        : `${FASTFOOD_RECORDS_API}/expenses`;

      const res = isEdit
        ? await axios.put(url, payload, {
            headers: { Authorization: `Bearer ${token}` },
          })
        : await axios.post(url, payload, {
            headers: { Authorization: `Bearer ${token}` },
          });

      if (!res?.data?.success) {
        showMessage(res?.data?.message || 'Expense could not be saved.', 'error');
        return;
      }

      showMessage(res.data.message || (isEdit ? 'Expense updated successfully.' : 'Expense saved successfully.'));
      resetExpenseForm();
      await fetchExpenses();
    } catch (err) {
      showMessage(
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          'Expense could not be saved.',
        'error'
      );
    } finally {
      setExpenseSaving(false);
    }
  };

  const deleteExpense = async (expense) => {
    const expenseId = expense?.id || expense?.expenseId;
    const token = getToken();

    if (!expenseId || !token) return;

    const ok = window.confirm('Do you want to delete this expense?');
    if (!ok) return;

    try {
      setExpenseSaving(true);

      const res = await axios.delete(`${FASTFOOD_RECORDS_API}/expenses/${expenseId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!res?.data?.success) {
        showMessage(res?.data?.message || 'Expense could not be deleted.', 'error');
        return;
      }

      showMessage(res.data.message || 'Expense deleted successfully.');
      await fetchExpenses();
    } catch (err) {
      showMessage(
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          'Expense could not be deleted.',
        'error'
      );
    } finally {
      setExpenseSaving(false);
    }
  };

  const openExpensePaymentBox = (expense) => {
    const due = getExpenseDueAmount(expense);

    if (due <= 0) {
      showMessage('This expense has no pending due.', 'error');
      return;
    }

    setExpensePaymentBox({
      open: true,
      expense,
      amount: '',
      method: 'cash',
      referenceNo: '',
      note: '',
    });
  };

  const closeExpensePaymentBox = () => {
    setExpensePaymentBox({
      open: false,
      expense: null,
      amount: '',
      method: 'cash',
      referenceNo: '',
      note: '',
    });
  };

  const submitExpensePayment = async () => {
    if (expenseSaving) return;

    const token = getToken();
    const expense = expensePaymentBox.expense;
    const expenseId = expense?.id || expense?.expenseId;
    const due = getExpenseDueAmount(expense);
    const amount = toNumber(expensePaymentBox.amount, 0);

    if (!token || !expenseId) {
      showMessage('No expense selected.', 'error');
      return;
    }

    if (amount <= 0) {
      showMessage('Please enter a valid payment amount.', 'error');
      return;
    }

    if (amount > due) {
      showMessage(`Payment cannot be greater than pending due. Max ${formatMoney(due)}.`, 'error');
      return;
    }

    try {
      setExpenseSaving(true);

      const res = await axios.post(
        `${FASTFOOD_RECORDS_API}/expenses/${expenseId}/payment`,
        {
          amount,
          method: expensePaymentBox.method,
          referenceNo: expensePaymentBox.referenceNo,
          note: expensePaymentBox.note,
        },
        {
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        }
      );

      if (!res?.data?.success) {
        showMessage(res?.data?.message || 'Expense payment could not be saved.', 'error');
        return;
      }

      showMessage(res.data.message || 'Expense payment saved successfully.');
      closeExpensePaymentBox();
      await fetchExpenses();
    } catch (err) {
      showMessage(
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          'Expense payment could not be saved.',
        'error'
      );
    } finally {
      setExpenseSaving(false);
    }
  };

  const resetFilters = () => {
    setSearch('');
    setPaymentStatus('all');
    setPaymentMethod('all');
    setOrderMode('all');
    setExpenseCategory('all');
    setExpenseStatus('all');
    setDatePreset('today');
    setCustomFrom('');
    setCustomTo('');
  };

  const downloadCsvFile = (rows, fileName) => {
    const csv = rows
      .map((row) =>
        row
          .map((cell) => {
            const value = String(cell ?? '').replace(/"/g, '""');
            return `"${value}"`;
          })
          .join(',')
      )
      .join('\n');

    const blob = new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();

    window.URL.revokeObjectURL(url);
  };

  const exportCsv = () => {
    const rows = [
      [
        'Order No',
        'Bill No',
        'Date',
        'Customer',
        'Mobile',
        'Order Type',
        'Items',
        'Total',
        'Paid',
        'Due',
        'Payment Status',
        'Payment Method',
      ],
      ...filteredOrders.map((order) => [
        order.orderNo,
        order.billNo,
        formatDateTime(order.recordDate),
        order.customerName,
        order.customerMobile,
        getModeLabel(order.displayMode),
        order.itemCount,
        order.finalTotal,
        order.amountPaid,
        order.dueAmount,
        getPaymentStatusLabel(order.displayPaymentStatus),
        order.displayPaymentMethod,
      ]),
    ];

    downloadCsvFile(rows, `fast-food-records-${Date.now()}.csv`);
  };

  const exportExpenseCsv = () => {
    if (!filteredExpenses.length) {
      showMessage('No expense records available to export.', 'error');
      return;
    }

    const rows = [
      [
        'Expense ID',
        'Date',
        'Category',
        'Expense Title',
        'Paid To Name',
        'Paid To Mobile',
        'Total Amount',
        'Paid Amount',
        'Due Amount',
        'Payment Status',
        'Payment Method',
        'Reference No',
        'Receipt URL',
        'Note',
      ],
      ...filteredExpenses.map((expense) => {
        const category = expense.expenseCategory || expense.expense_category || 'other';
        const status = getExpensePaymentStatus(expense);
        const method = expense.paymentMethod || expense.payment_method || 'cash';
        const receiptUrl = getExpenseReceiptUrl(expense) || '';

        return [
          expense.id || expense.expenseId || expense.expense_id || '',
          formatDateOnly(expense.expenseDate || expense.expense_date),
          getExpenseCategoryLabel(category),
          expense.expenseTitle || expense.expense_title || 'Expense',
          expense.paidToName || expense.paid_to_name || '',
          expense.paidToMobile || expense.paid_to_mobile || '',
          getExpenseTotalAmount(expense),
          getExpensePaidAmount(expense),
          getExpenseDueAmount(expense),
          getExpensePaymentStatusLabel(status),
          method,
          expense.referenceNo || expense.reference_no || '',
          receiptUrl,
          expense.note || '',
        ];
      }),
    ];

    downloadCsvFile(rows, `fast-food-expenses-${Date.now()}.csv`);
    showMessage('Expense records exported successfully.');
  };

  const printSelectedBill = () => {
    if (!selectedOrder) return;

    const products = selectedOrder.productsParsed || [];

    const rows = products
      .map((item) => {
        const name = item?.name || item?.item_name || 'Item';
        const qty = toNumber(item?.quantity || item?.qty, 1);
        const rate = toNumber(item?.price ?? item?.selling_price ?? item?.rate, 0);
        const total = qty * rate;

        return `
          <tr>
            <td>${name}</td>
            <td>${qty}</td>
            <td>${Math.round(rate)}</td>
            <td>${Math.round(total)}</td>
          </tr>
        `;
      })
      .join('');

    const html = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>${selectedOrder.billNo}</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              padding: 12px;
              color: #111;
            }

            .receipt {
              width: 280px;
              margin: 0 auto;
            }

            h2, p {
              text-align: center;
              margin: 0;
            }

            h2 {
              font-size: 18px;
              margin-bottom: 4px;
            }

            p {
              font-size: 12px;
            }

            .line {
              border-top: 1px dashed #111;
              margin: 10px 0;
            }

            .row {
              display: flex;
              justify-content: space-between;
              gap: 10px;
              font-size: 12px;
              margin: 5px 0;
            }

            .row strong {
              text-align: right;
            }

            table {
              width: 100%;
              border-collapse: collapse;
              font-size: 12px;
            }

            th, td {
              padding: 5px 2px;
              border-bottom: 1px dashed #ccc;
              text-align: left;
            }

            th:nth-child(2),
            td:nth-child(2) {
              text-align: center;
            }

            th:nth-child(3),
            td:nth-child(3),
            th:nth-child(4),
            td:nth-child(4) {
              text-align: right;
            }

            @media print {
              @page {
                size: 80mm auto;
                margin: 4mm;
              }
            }
          </style>
        </head>
        <body>
          <div class="receipt">
            <h2>Fast Food Bill</h2>
            <p>${selectedOrder.billNo}</p>
            <div class="line"></div>

            <div class="row"><span>Order</span><strong>${selectedOrder.orderNo}</strong></div>
            <div class="row"><span>Date</span><strong>${formatDateTime(selectedOrder.recordDate)}</strong></div>
            <div class="row"><span>Customer</span><strong>${selectedOrder.customerName}</strong></div>
            ${
              selectedOrder.customerMobile
                ? `<div class="row"><span>Mobile</span><strong>${selectedOrder.customerMobile}</strong></div>`
                : ''
            }
            <div class="row"><span>Type</span><strong>${getModeLabel(selectedOrder.displayMode)}</strong></div>
            <div class="line"></div>

            <table>
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Qty</th>
                  <th>Rate</th>
                  <th>Amt</th>
                </tr>
              </thead>
              <tbody>
                ${
                  rows ||
                  `<tr><td colspan="4" style="text-align:center;">No items</td></tr>`
                }
              </tbody>
            </table>

            <div class="line"></div>
            <div class="row"><span>Total</span><strong>${formatMoney(selectedOrder.finalTotal)}</strong></div>
            <div class="row"><span>Paid</span><strong>${formatMoney(selectedOrder.amountPaid)}</strong></div>
            <div class="row"><span>Due</span><strong>${formatMoney(selectedOrder.dueAmount)}</strong></div>
            <div class="row"><span>Payment</span><strong>${getPaymentStatusLabel(
              selectedOrder.displayPaymentStatus
            )}</strong></div>
            <div class="line"></div>
            <p>Thank you! Visit again.</p>
          </div>

          <script>
            window.onload = function () {
              window.print();
              setTimeout(function () {
                window.close();
              }, 500);
            };
          </script>
        </body>
      </html>
    `;

    const win = window.open('', '_blank', 'width=360,height=640');
    if (win) {
      win.document.write(html);
      win.document.close();
    }
  };

  const openDueCustomer = (customer) => {
    const key =
      customer.customerKey ||
      customer.customerMobile ||
      customer.customer_mobile ||
      customer.customerName ||
      customer.customer_name;

    setSelectedCustomerKey(key);
    setActiveSection('khata');
    scrollToSection(khataRef);
  };

  const openPaymentBox = ({ customer, bill = null, type = 'partial' }) => {
    const billDue = bill ? getBillRemainingDue(bill) : 0;
    const customerDue = getCustomerPayableDue(customer);
    const due = bill ? billDue : customerDue;

    if (!customer) {
      showMessage('No customer selected.', 'error');
      return;
    }

    if (due <= 0) {
      showMessage('This customer/bill has no pending due.', 'error');
      return;
    }

    setPaymentBox({
      open: true,
      type,
      customer,
      bill,
      amount: type === 'full' ? String(due) : '',
      method: 'cash',
      note: '',
      referenceNo: '',
    });
  };

  const closePaymentBox = () => {
    setPaymentBox({
      open: false,
      type: 'partial',
      customer: null,
      bill: null,
      amount: '',
      method: 'cash',
      note: '',
      referenceNo: '',
    });
  };

  const submitLocalPayment = async () => {
    const amount = toNumber(paymentBox.amount, 0);

    if (savingPayment) return;

    if (!paymentBox.customer) {
      showMessage('No customer selected.', 'error');
      return;
    }

    if (!amount || amount <= 0) {
      showMessage('Payment amount sahi डालें.', 'error');
      return;
    }

    const billDue = paymentBox.bill ? getBillRemainingDue(paymentBox.bill) : 0;
    const customerDue = getCustomerPayableDue(paymentBox.customer);
    const payableDue = paymentBox.bill ? billDue : customerDue;

    if (payableDue <= 0) {
      showMessage('Pending amount is already cleared.', 'error');
      return;
    }

    if (amount > payableDue) {
      showMessage(`Amount cannot be greater than pending due. Max ${formatMoney(payableDue)}.`, 'error');
      return;
    }

    const token = getToken();

    if (!token) {
      showMessage('Login token is missing. Please login again.', 'error');
      return;
    }

    const customerKey =
      paymentBox.customer.customerKey ||
      paymentBox.customer.customerMobile ||
      paymentBox.customer.customerName;

    const paymentStatusAfter = amount >= payableDue ? 'paid' : 'partial';

    try {
      setSavingPayment(true);

      const payload = {
        billId: paymentBox.bill?.billId || paymentBox.bill?.bill_id || paymentBox.bill?.id || null,
        orderId: paymentBox.bill?.orderId || paymentBox.bill?.order_id || null,
        billNo: paymentBox.bill?.billNo || paymentBox.bill?.bill_no || null,
        customerName: paymentBox.customer.customerName || paymentBox.customer.customer_name || '',
        customerMobile: paymentBox.customer.customerMobile || paymentBox.customer.customer_mobile || '',
        amount,
        method: paymentBox.method,
        referenceNo: paymentBox.referenceNo,
        note: paymentBox.note,
        paymentType: paymentBox.type,
      };

      const res = await axios.post(
        `${FASTFOOD_RECORDS_API}/customer-payment`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (!res?.data?.success) {
        showMessage(res?.data?.message || 'Payment could not be saved.', 'error');
        return;
      }

      setLocalPayments((prev) => [
        {
          id: `server_payment_${Date.now()}`,
          customerKey,
          customerName: payload.customerName,
          customerMobile: payload.customerMobile,
          billId: payload.billId,
          billNo: payload.billNo,
          amount,
          method: paymentBox.method,
          note: paymentBox.note,
          referenceNo: paymentBox.referenceNo,
          paymentType: paymentBox.type,
          paymentStatusAfter,
          payableBefore: payableDue,
          createdAt: new Date().toISOString(),
        },
        ...prev,
      ]);

      showMessage(res.data.message || 'Payment saved successfully.');
      closePaymentBox();

      setTimeout(async () => {
        setLocalPayments([]);
        await fetchRecords();
      }, 250);
    } catch (err) {
      showMessage(
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          'Payment could not be saved.',
        'error'
      );
    } finally {
      setSavingPayment(false);
    }
  };

  const getFastMovingStatus = (item) => {
    const qty = toNumber(item.qty ?? item.quantity_sold, 0);

    if (qty >= 100) return { label: 'Fast Moving', className: 'fast' };
    if (qty >= 30) return { label: 'Normal', className: 'normal' };

    return { label: 'Low Sale', className: 'low' };
  };

  const renderSectionTabs = () => (
    <div className="ffr-section-tabs">
      {SECTION_TABS.map((tab) => (
        <button
          key={tab.value}
          type="button"
          className={`ffr-section-tab ${activeSection === tab.value ? 'active' : ''}`}
          onClick={() => {
            setActiveSection(tab.value);

            if (tab.value === 'bills') {
              scrollToSection(billsRef);
            } else if (tab.value === 'products') {
              scrollToSection(productsRef);
            } else if (tab.value === 'khata') {
              scrollToSection(khataRef);
            } else if (tab.value === 'expenses') {
              scrollToSection(expensesRef);
            }
          }}
        >
          <span>{tab.icon}</span>
          <strong>{tab.label}</strong>
        </button>
      ))}
    </div>
  );

  const renderSummaryCards = () => (
    <div className="ffr-summary-grid">
      <button type="button" className="ffr-summary-card purple clickable" onClick={() => openBillsSection('all')}>
        <div className="ffr-summary-icon">🧾</div>
        <div>
          <span>Total Bills</span>
          <strong>{summary.totalOrders}</strong>
          <small>Bills</small>
        </div>
      </button>

      <button type="button" className="ffr-summary-card green clickable" onClick={() => openBillsSection('paid')}>
        <div className="ffr-summary-icon">💵</div>
        <div>
          <span>Paid Amount</span>
          <strong>{formatShortMoney(summary.paidAmount)}</strong>
          <small>Total Paid</small>
        </div>
      </button>

      <button type="button" className="ffr-summary-card orange clickable" onClick={() => openBillsSection('due')}>
        <div className="ffr-summary-icon">💰</div>
        <div>
          <span>Due Amount</span>
          <strong>{formatShortMoney(summary.dueAmount)}</strong>
          <small>Total Due</small>
        </div>
      </button>

      <button type="button" className="ffr-summary-card blue clickable" onClick={openProductsSection}>
        <div className="ffr-summary-icon">📊</div>
        <div>
          <span>Products Sold</span>
          <strong>{summary.productQty}</strong>
          <small>Qty</small>
        </div>
      </button>

      <button type="button" className="ffr-summary-card teal clickable" onClick={openProductsSection}>
        <div className="ffr-summary-icon">📈</div>
        <div>
          <span>Product Sales Value</span>
          <strong>{formatShortMoney(summary.productSalesValue)}</strong>
          <small>Total Sales</small>
        </div>
      </button>

      <button type="button" className="ffr-summary-card red clickable" onClick={openKhataSection}>
        <div className="ffr-summary-icon">👥</div>
        <div>
          <span>Due Customers</span>
          <strong>{summary.dueCustomers}</strong>
          <small>Customers</small>
        </div>
      </button>

      <button type="button" className="ffr-summary-card pink clickable" onClick={openExpensesSection}>
        <div className="ffr-summary-icon">💸</div>
        <div>
          <span>Total Expense</span>
          <strong>{formatShortMoney(totalExpense)}</strong>
          <small>Shop Kharcha</small>
        </div>
      </button>

    </div>
  );

  const renderFilters = () => (
    <div className="ffr-filter-card">
      <div className="ffr-filter-left">
        <label>
          <span>Date Range</span>
          <select value={datePreset} onChange={(e) => setDatePreset(e.target.value)}>
            {DATE_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
        </label>

        {datePreset === 'custom' ? (
          <>
            <label>
              <span>From</span>
              <input type="date" value={customFrom} onChange={(e) => setCustomFrom(e.target.value)} />
            </label>

            <label>
              <span>To</span>
              <input type="date" value={customTo} onChange={(e) => setCustomTo(e.target.value)} />
            </label>
          </>
        ) : null}

        <label>
          <span>Payment Status</span>
          <select value={paymentStatus} onChange={(e) => setPaymentStatus(e.target.value)}>
            {PAYMENT_STATUS_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
        </label>

        <label>
          <span>Payment Method</span>
          <select value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)}>
            {PAYMENT_METHOD_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
        </label>

        <label>
          <span>Order Mode</span>
          <select value={orderMode} onChange={(e) => setOrderMode(e.target.value)}>
            {ORDER_MODE_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
        </label>

        <label>
          <span>Expense Category</span>
          <select value={expenseCategory} onChange={(e) => setExpenseCategory(e.target.value)}>
            {EXPENSE_CATEGORY_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
        </label>

        <label>
          <span>Expense Status</span>
          <select value={expenseStatus} onChange={(e) => setExpenseStatus(e.target.value)}>
            {EXPENSE_PAYMENT_STATUS_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
        </label>

        <label className="ffr-filter-search">
          <span>Search by Customer / Bill</span>
          <input
            type="text"
            value={search}
            placeholder="Enter name, mobile, product or bill no..."
            onChange={(e) => setSearch(e.target.value)}
          />
        </label>
      </div>

      <div className="ffr-filter-actions">
        <button type="button" className="ffr-white-btn" onClick={resetFilters}>↻ Reset</button>
        <button type="button" className="ffr-primary-btn" onClick={refreshAllRecords}>Refresh</button>
        <button type="button" className="ffr-white-btn" onClick={exportCsv}>Export</button>
      </div>
    </div>
  );

  const renderBillsTable = () => (
    <div className="ffr-panel-card">
      <div className="ffr-panel-head">
        <div>
          <h2>Recent Bills Record</h2>
          <p>
            Showing {filteredOrders.length ? 1 : 0} to {Math.min(filteredOrders.length, 10)} of{' '}
            {filteredOrders.length} entries
          </p>
        </div>

        <button type="button" className="ffr-white-btn" onClick={resetFilters}>↻ Reset</button>
      </div>

      <div className="ffr-table-wrap">
        <table className="ffr-record-table ffr-compact-table">
          <thead>
            <tr>
              <th>Bill No</th>
              <th>Date</th>
              <th>Customer</th>
              <th>Mode</th>
              <th>Total</th>
              <th>Paid</th>
              <th>Due</th>
              <th>Method</th>
              <th>Status</th>
              <th>View</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="10" className="ffr-empty-cell">Loading records...</td>
              </tr>
            ) : filteredOrders.length === 0 ? (
              <tr>
                <td colSpan="10" className="ffr-empty-cell">No records found.</td>
              </tr>
            ) : (
              filteredOrders.map((order) => (
                <tr key={order.id} className={selectedOrder?.id === order.id ? 'selected' : ''}>
                  <td>
                    <strong>{order.billNo}</strong>
                    <small className="ffr-table-sub">{order.orderNo}</small>
                  </td>

                  <td>{formatDateTime(order.recordDate)}</td>

                  <td>
                    <div className="ffr-customer-cell">
                      <strong>{order.customerName}</strong>
                      <span>{order.customerMobile || '-'}</span>
                    </div>
                  </td>

                  <td>
                    <span className={`ffr-mode-pill ${order.displayMode}`}>
                      {getModeLabel(order.displayMode)}
                    </span>
                  </td>

                  <td>{formatMoney(order.finalTotal)}</td>
                  <td className="green-text">{formatMoney(order.amountPaid)}</td>

                  <td className={order.dueAmount > 0 ? 'red-text' : ''}>
                    {formatMoney(order.dueAmount)}
                  </td>

                  <td>
                    <span className={`ffr-method-pill ${order.displayPaymentMethod}`}>
                      {order.displayPaymentMethod || '-'}
                    </span>
                  </td>

                  <td>
                    <span className={`ffr-status-pill ${order.displayPaymentStatus}`}>
                      {getPaymentStatusLabel(order.displayPaymentStatus)}
                    </span>
                  </td>

                  <td>
                    <button type="button" className="ffr-view-btn" onClick={() => setSelectedOrderId(order.id)}>
                      👁
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="ffr-mobile-record-list">
        {loading ? (
          <div className="ffr-empty-box">Loading records...</div>
        ) : filteredOrders.length === 0 ? (
          <div className="ffr-empty-box">No records found.</div>
        ) : (
          filteredOrders.map((order) => (
            <button
              key={order.id}
              type="button"
              className={`ffr-mobile-record-card ${selectedOrder?.id === order.id ? 'selected' : ''}`}
              onClick={() => setSelectedOrderId(order.id)}
            >
              <div className="ffr-mobile-record-one-line">
                <div>
                  <strong>{order.billNo}</strong>
                  <span>{order.customerName}</span>
                </div>

                <div>
                  <b>{formatMoney(order.finalTotal)}</b>
                  <span className={order.dueAmount > 0 ? 'red-text' : 'green-text'}>
                    Due: {formatMoney(order.dueAmount)}
                  </span>
                </div>

                <span className={`ffr-status-pill ${order.displayPaymentStatus}`}>
                  {getPaymentStatusLabel(order.displayPaymentStatus)}
                </span>
              </div>
            </button>
          ))
        )}
      </div>
    </div>
  );

  const renderSelectedBill = () => (
    <div className="ffr-panel-card ffr-selected-card">
      <div className="ffr-panel-head">
        <div>
          <h2>Selected Bill Summary</h2>
          <p>Short bill details</p>
        </div>
      </div>

      {!selectedOrder ? (
        <div className="ffr-empty-box">Select a bill.</div>
      ) : (
        <>
          <div className="ffr-selected-info">
            <div>
              <span>Bill No</span>
              <strong>{selectedOrder.billNo}</strong>
            </div>

            <div>
              <span>Customer</span>
              <strong>{selectedOrder.customerName}</strong>
            </div>

            <div>
              <span>Mobile</span>
              <strong>{selectedOrder.customerMobile || '-'}</strong>
            </div>

            <div>
              <span>Total Amount</span>
              <strong>{formatMoney(selectedOrder.finalTotal)}</strong>
            </div>

            <div>
              <span>Paid Amount</span>
              <strong className="green-text">{formatMoney(selectedOrder.amountPaid)}</strong>
            </div>

            <div>
              <span>Due Amount</span>
              <strong className={selectedOrder.dueAmount > 0 ? 'red-text' : 'green-text'}>
                {formatMoney(selectedOrder.dueAmount)}
              </strong>
            </div>

            <div>
              <span>Payment Method</span>
              <strong>{selectedOrder.displayPaymentMethod || '-'}</strong>
            </div>
          </div>

          <div className="ffr-selected-actions">
            <button type="button" onClick={() => setBillModalOpen(true)}>👁 View Bill</button>
            <button type="button" onClick={printSelectedBill}>🖨 Print</button>
          </div>
        </>
      )}
    </div>
  );

  const renderTopProducts = () => (
    <div className="ffr-panel-card">
      <div className="ffr-panel-head">
        <div>
          <h2>Top Selling Products</h2>
          <p>Top selling items in this period</p>
        </div>
      </div>

      <div className="ffr-product-list">
        {productSales.length === 0 ? (
          <div className="ffr-empty-box">No product sales records found.</div>
        ) : (
          productSales.slice(0, 8).map((item, index) => (
            <div className="ffr-product-row" key={`${item.name}_${index}`}>
              <div className="ffr-product-rank">{index + 1}</div>

              <div className="ffr-product-main">
                <strong>{item.name}</strong>
                <span>{item.orderCount || item.order_count || 0} orders</span>
              </div>

              <div className="ffr-product-number">
                <strong>{item.qty || item.quantity_sold || 0}</strong>
                <span>Qty</span>
              </div>

              <div className="ffr-product-sales">
                <strong>{formatMoney(item.sales || item.total_sales || 0)}</strong>
                <span>{toNumber(item.percent || item.percentage, 0).toFixed(1)}%</span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );

  const renderDueCustomersPanel = () => (
    <div className="ffr-panel-card">
      <div className="ffr-panel-head">
        <div>
          <h2>Due Customers</h2>
          <p>Customers with pending payments</p>
        </div>
      </div>

      <div className="ffr-due-list">
        {dueCustomers.length === 0 ? (
          <div className="ffr-empty-box">No due customers found.</div>
        ) : (
          dueCustomers.slice(0, 8).map((customer) => (
            <div className="ffr-due-row" key={`${customer.customerKey}_${customer.customerMobile}_${customer.customerName}`}>
              <button type="button" className="ffr-due-main-click" onClick={() => openDueCustomer(customer)}>
                <div>
                  <strong>{customer.customerName}</strong>
                  <span>{customer.customerMobile || '-'}</span>
                </div>

                <div>
                  <strong className="red-text">{formatMoney(customer.dueAmount)}</strong>
                  <span>{customer.totalOrders} bills</span>
                </div>
              </button>

              <button type="button" className="ffr-mini-outline-btn" onClick={() => openDueCustomer(customer)}>
                View
              </button>

              <button type="button" className="ffr-mini-pay-btn" onClick={() => openPaymentBox({ customer, type: 'partial' })}>
                Collect
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );

  const renderProductSalesSection = () => (
    <div className="ffr-panel-card ffr-product-full">
      <div className="ffr-panel-head">
        <div>
          <h2>Product-wise Sales Record</h2>
          <p>Sold quantity, sales amount, and movement status for each product.</p>
        </div>
      </div>

      <div className="ffr-table-wrap">
        <table className="ffr-record-table ffr-compact-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Product</th>
              <th>Sold Qty</th>
              <th>Sales Amount</th>
              <th>Orders</th>
              <th>% of Sale</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {productSales.length === 0 ? (
              <tr>
                <td colSpan="7" className="ffr-empty-cell">No product sales records found.</td>
              </tr>
            ) : (
              productSales.map((item, index) => {
                const status = getFastMovingStatus(item);

                return (
                  <tr key={`${item.name}_${index}`}>
                    <td>{index + 1}</td>
                    <td><strong>{item.name}</strong></td>
                    <td>{item.qty || item.quantity_sold || 0}</td>
                    <td>{formatMoney(item.sales || item.total_sales || 0)}</td>
                    <td>{item.orderCount || item.order_count || 0}</td>
                    <td>{toNumber(item.percent || item.percentage, 0).toFixed(2)}%</td>
                    <td>
                      <span className={`ffr-product-status ${status.className}`}>
                        {status.label}
                      </span>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      <div className="ffr-mobile-product-list">
        {productSales.length === 0 ? (
          <div className="ffr-empty-box">No product sales records found.</div>
        ) : (
          productSales.map((item, index) => {
            const status = getFastMovingStatus(item);

            return (
              <div className="ffr-mobile-product-card one-row" key={`${item.name}_${index}`}>
                <div>
                  <strong>{index + 1}. {item.name}</strong>
                  <span>{item.orderCount || item.order_count || 0} orders</span>
                </div>

                <div>
                  <b>{item.qty || item.quantity_sold || 0} Qty</b>
                  <span>{formatMoney(item.sales || item.total_sales || 0)}</span>
                </div>

                <span className={`ffr-product-status ${status.className}`}>
                  {status.label}
                </span>
              </div>
            );
          })
        )}
      </div>
    </div>
  );

  const renderCustomerKhataSection = () => (
    <div className="ffr-khata-grid" ref={khataRef}>
      <div className="ffr-panel-card">
        <div className="ffr-panel-head">
          <div>
            <h2>Customer Khata</h2>
            <p>Paid, partial, and pending bill summary.</p>
          </div>
        </div>

        <div className="ffr-due-list">
          {customerRecords.length === 0 ? (
            <div className="ffr-empty-box">No customer records found.</div>
          ) : (
            customerRecords.map((customer) => {
              const key = customer.customerKey || customer.customerMobile || customer.customerName;
              const active = String(key) === String(selectedCustomerKey);

              return (
                <button
                  type="button"
                  className={`ffr-customer-khata-row ${active ? 'active' : ''}`}
                  key={`${customer.customerKey}_${customer.customerMobile}_${customer.customerName}`}
                  onClick={() => openDueCustomer(customer)}
                >
                  <div className="ffr-avatar">
                    {String(customer.customerName || 'C').slice(0, 1).toUpperCase()}
                  </div>

                  <div>
                    <strong>{customer.customerName}</strong>
                    <span>{customer.customerMobile || '-'}</span>
                  </div>

                  <div>
                    <b className={customer.dueAmount > 0 ? 'red-text' : 'green-text'}>
                      {formatMoney(customer.dueAmount)}
                    </b>
                    <span>{customer.totalOrders} bills</span>
                  </div>
                </button>
              );
            })
          )}
        </div>
      </div>

      <div className="ffr-panel-card">
        <div className="ffr-panel-head">
          <div>
            <h2>Customer Full Record</h2>
            <p>Purchase, paid, due aur bill-wise history.</p>
          </div>
        </div>

        {!selectedCustomer ? (
          <div className="ffr-empty-box">Select a customer.</div>
        ) : (
          <>
            <div className="ffr-khata-profile">
              <div className="ffr-avatar large">
                {String(selectedCustomer.customerName || 'C').slice(0, 1).toUpperCase()}
              </div>

              <div>
                <h3>{selectedCustomer.customerName}</h3>
                <p>{selectedCustomer.customerMobile || '-'}</p>
              </div>

              <div>
                <span>Total Due</span>
                <strong>{formatMoney(selectedCustomer.dueAmount)}</strong>
              </div>
            </div>

            <div className="ffr-khata-mini-stats">
              <div>
                <span>Total Purchase</span>
                <strong>{formatMoney(selectedCustomer.totalPurchase)}</strong>
              </div>

              <div>
                <span>Total Paid</span>
                <strong className="green-text">{formatMoney(selectedCustomer.totalPaid)}</strong>
              </div>

              <div>
                <span>Total Due</span>
                <strong className={selectedCustomer.dueAmount > 0 ? 'red-text' : 'green-text'}>
                  {formatMoney(selectedCustomer.dueAmount)}
                </strong>
              </div>

              <div>
                <span>Total Bills</span>
                <strong>{selectedCustomer.totalOrders}</strong>
              </div>

              <div>
                <span>Paid Bills</span>
                <strong className="green-text">{selectedCustomer.paidBills}</strong>
              </div>

              <div>
                <span>Partial Bills</span>
                <strong>{selectedCustomer.partialBills}</strong>
              </div>

              <div>
                <span>Unpaid Bills</span>
                <strong className="red-text">{selectedCustomer.unpaidBills}</strong>
              </div>

              <div>
                <span>Last Bill</span>
                <strong>{formatDateTime(selectedCustomer.lastOrderDate)}</strong>
              </div>
            </div>

            <div className="ffr-selected-actions">
              <button type="button" disabled={savingPayment} onClick={() => openPaymentBox({ customer: selectedCustomer, type: 'partial' })}>
                ₹ Partial Payment
              </button>

              <button type="button" disabled={savingPayment} onClick={() => openPaymentBox({ customer: selectedCustomer, type: 'full' })}>
                ✅ Full Payment
              </button>
            </div>

            <div className="ffr-customer-bills-box">
              <div className="ffr-panel-head compact">
                <div>
                  <h2>Bill-wise Records</h2>
                  <p>Customer ke sabhi bills.</p>
                </div>
              </div>

              <div className="ffr-customer-bill-list">
                {(selectedCustomer.bills || []).length === 0 ? (
                  <div className="ffr-empty-box">No bill records found.</div>
                ) : (
                  selectedCustomer.bills.map((bill) => {
                    const adjustedPaid = getBillAdjustedPaid(bill);
                    const remainingDue = getBillRemainingDue(bill);
                    const adjustedStatus = getBillAdjustedStatus(bill);

                    return (
                      <div className="ffr-customer-bill-card" key={bill.id}>
                        <div>
                          <strong>{bill.billNo}</strong>
                          <span>{formatDateTime(bill.recordDate)}</span>
                        </div>

                        <div>
                          <span>Total</span>
                          <strong>{formatMoney(bill.finalTotal)}</strong>
                        </div>

                        <div>
                          <span>Paid</span>
                          <strong className="green-text">{formatMoney(adjustedPaid)}</strong>
                        </div>

                        <div>
                          <span>Due</span>
                          <strong className={remainingDue > 0 ? 'red-text' : 'green-text'}>
                            {formatMoney(remainingDue)}
                          </strong>
                        </div>

                        <div>
                          <span className={`ffr-status-pill ${adjustedStatus}`}>
                            {getPaymentStatusLabel(adjustedStatus)}
                          </span>
                        </div>

                        {remainingDue > 0 ? (
                          <button
                            type="button"
                            className="ffr-mini-pay-btn"
                            disabled={savingPayment}
                            onClick={() =>
                              openPaymentBox({
                                customer: selectedCustomer,
                                bill,
                                type: 'partial',
                              })
                            }
                          >
                            Collect
                          </button>
                        ) : (
                          <span className="ffr-paid-mini">Paid</span>
                        )}
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );

  const renderExpenseSection = () => {
    const categorySummary =
      expenseSummary.categorySummary ||
      expenseSummary.category_summary ||
      [];

    return (
      <div className="ffr-expense-section" ref={expensesRef}>
        <div className="ffr-expense-dashboard-grid">
          <div className="ffr-panel-card ffr-expense-form-card">
            <div className="ffr-panel-head">
              <div>
                <h2>{expenseForm.id ? 'Edit Expense' : 'Add Shop Expense'}</h2>
                <p>Add raw material, staff payment, supplier payment, rent, gas, packaging, or other expenses.</p>
              </div>

              {expenseForm.id ? (
                <button type="button" className="ffr-white-btn" onClick={resetExpenseForm}>
                  + New
                </button>
              ) : null}
            </div>

            <div className="ffr-expense-form-grid">
              <label>
                <span>Date</span>
                <input
                  type="date"
                  value={expenseForm.expenseDate}
                  disabled={expenseSaving}
                  onChange={(e) => handleExpenseInputChange('expenseDate', e.target.value)}
                />
              </label>

              <label>
                <span>Category</span>
                <select
                  value={expenseForm.expenseCategory}
                  disabled={expenseSaving}
                  onChange={(e) => handleExpenseInputChange('expenseCategory', e.target.value)}
                >
                  {EXPENSE_CATEGORY_OPTIONS.filter((item) => item.value !== 'all').map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.icon} {option.label}
                    </option>
                  ))}
                </select>
              </label>

              <label className="ffr-expense-form-wide">
                <span>Expense Title</span>
                <input
                  type="text"
                  value={expenseForm.expenseTitle}
                  disabled={expenseSaving}
                  placeholder="Example: Today vegetable purchase / Staff advance"
                  onChange={(e) => handleExpenseInputChange('expenseTitle', e.target.value)}
                />
              </label>

              <label>
                <span>Total Amount</span>
                <input
                  type="number"
                  min="0"
                  value={expenseForm.totalAmount}
                  disabled={expenseSaving}
                  placeholder="0"
                  onChange={(e) => handleExpenseInputChange('totalAmount', e.target.value)}
                />
              </label>

              <label>
                <span>Paid Amount</span>
                <input
                  type="number"
                  min="0"
                  value={expenseForm.amountPaid}
                  disabled={expenseSaving}
                  placeholder="0"
                  onChange={(e) => handleExpenseInputChange('amountPaid', e.target.value)}
                />
              </label>

              <label>
                <span>Payment Method</span>
                <select
                  value={expenseForm.paymentMethod}
                  disabled={expenseSaving}
                  onChange={(e) => handleExpenseInputChange('paymentMethod', e.target.value)}
                >
                  {EXPENSE_PAYMENT_METHOD_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>
              </label>

              <label>
                <span>Paid To Name</span>
                <input
                  type="text"
                  value={expenseForm.paidToName}
                  disabled={expenseSaving}
                  placeholder="Supplier / Staff name"
                  onChange={(e) => handleExpenseInputChange('paidToName', e.target.value)}
                />
              </label>

              <label>
                <span>Mobile</span>
                <input
                  type="text"
                  value={expenseForm.paidToMobile}
                  disabled={expenseSaving}
                  placeholder="Optional"
                  onChange={(e) => handleExpenseInputChange('paidToMobile', e.target.value)}
                />
              </label>

              <label>
                <span>Reference No</span>
                <input
                  type="text"
                  value={expenseForm.referenceNo}
                  disabled={expenseSaving}
                  placeholder="UPI/Bank ref optional"
                  onChange={(e) => handleExpenseInputChange('referenceNo', e.target.value)}
                />
              </label>

              <label className="ffr-expense-form-wide">
                <span>Note</span>
                <input
                  type="text"
                  value={expenseForm.note}
                  disabled={expenseSaving}
                  placeholder="Optional note"
                  onChange={(e) => handleExpenseInputChange('note', e.target.value)}
                />
              </label>


              <label className="ffr-expense-form-wide ffr-receipt-upload-label">
                <span>Receipt Photo</span>
                <input
                  type="file"
                  accept="image/*"
                  disabled={expenseSaving}
                  onChange={(e) => handleExpenseReceiptChange(e.target.files?.[0] || null)}
                />
                <small>Optional: upload bill/receipt photo, max 5 MB.</small>
              </label>

              {expenseForm.receiptPreview ? (
                <div className="ffr-expense-form-wide ffr-receipt-preview-card">
                  <img src={expenseForm.receiptPreview} alt="Expense receipt preview" />
                  <div>
                    <strong>Receipt Selected</strong>
                    <span>Image will be saved with this expense.</span>
                    <button
                      type="button"
                      className="ffr-mini-outline-btn"
                      disabled={expenseSaving}
                      onClick={() => setExpenseForm((prev) => ({ ...prev, receiptFile: null, receiptPreview: '', billImage: '' }))}
                    >
                      Remove Receipt
                    </button>
                  </div>
                </div>
              ) : null}
            </div>

            <div className="ffr-expense-live-summary">
              <div>
                <span>Total</span>
                <strong>{formatMoney(toNumber(expenseForm.totalAmount, 0))}</strong>
              </div>
              <div>
                <span>Paid</span>
                <strong className="green-text">{formatMoney(toNumber(expenseForm.amountPaid, 0))}</strong>
              </div>
              <div>
                <span>Due</span>
                <strong className={Math.max(0, toNumber(expenseForm.totalAmount, 0) - toNumber(expenseForm.amountPaid, 0)) > 0 ? 'red-text' : 'green-text'}>
                  {formatMoney(Math.max(0, toNumber(expenseForm.totalAmount, 0) - toNumber(expenseForm.amountPaid, 0)))}
                </strong>
              </div>
            </div>

            <div className="ffr-selected-actions">
              <button type="button" disabled={expenseSaving} onClick={submitExpense}>
                {expenseSaving ? 'Saving...' : expenseForm.id ? 'Update Expense' : 'Save Expense'}
              </button>
              <button type="button" disabled={expenseSaving} onClick={resetExpenseForm}>
                Clear
              </button>
            </div>
          </div>

          <div className="ffr-panel-card ffr-expense-side-card">
            <div className="ffr-panel-head">
              <div>
                <h2>Expense Summary</h2>
                <p>{dateRange.label}  shop expenses.</p>
              </div>
            </div>

            <div className="ffr-expense-summary-list">
              <div>
                <span>Total Expense</span>
                <strong>{formatMoney(totalExpense)}</strong>
              </div>
              <div>
                <span>Expense Paid</span>
                <strong className="green-text">{formatMoney(expensePaid)}</strong>
              </div>
              <div>
                <span>Expense Due</span>
                <strong className={expenseDue > 0 ? 'red-text' : 'green-text'}>{formatMoney(expenseDue)}</strong>
              </div>
            </div>

            <div className="ffr-expense-category-box">
              <h3>Category Wise</h3>
              {!categorySummary.length ? (
                <div className="ffr-empty-box">No category summary found.</div>
              ) : (
                categorySummary.map((item) => {
                  const category = item.expense_category || item.expenseCategory || 'other';
                  return (
                    <div className="ffr-expense-category-row" key={category}>
                      <span>{getExpenseCategoryIcon(category)} {getExpenseCategoryLabel(category)}</span>
                      <strong>{formatMoney(item.total_amount || item.totalAmount || item.amount)}</strong>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </div>

        <div className="ffr-panel-card">
          <div className="ffr-panel-head">
            <div>
              <h2>Expense Records</h2>
              <p>{filteredExpenses.length} expense entries found.</p>
            </div>

            <div className="ffr-top-actions">
              <button type="button" className="ffr-white-btn" onClick={exportExpenseCsv}>
                Export Expenses
              </button>
              <button type="button" className="ffr-primary-btn" onClick={fetchExpenses}>
                ↻ Refresh Expenses
              </button>
            </div>
          </div>

          <div className="ffr-table-wrap ffr-expense-table-wrap">
            <table className="ffr-record-table ffr-expense-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Category</th>
                  <th>Title</th>
                  <th>Paid To</th>
                  <th>Total</th>
                  <th>Paid</th>
                  <th>Due</th>
                  <th>Method</th>
                  <th>Receipt</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {filteredExpenses.length === 0 ? (
                  <tr>
                    <td colSpan="11" className="ffr-empty-cell">No expense records found.</td>
                  </tr>
                ) : (
                  filteredExpenses.map((expense) => {
                    const expenseId = expense.id || expense.expenseId;
                    const category = expense.expenseCategory || expense.expense_category || 'other';
                    const due = getExpenseDueAmount(expense);
                    const status = getExpensePaymentStatus(expense);

                    return (
                      <tr key={expenseId} className={Number(selectedExpense?.id || selectedExpense?.expenseId) === Number(expenseId) ? 'selected' : ''}>
                        <td>{formatDateOnly(expense.expenseDate || expense.expense_date)}</td>
                        <td>
                          <span className="ffr-expense-category-pill">
                            {getExpenseCategoryIcon(category)} {getExpenseCategoryLabel(category)}
                          </span>
                        </td>
                        <td>
                          <strong>{expense.expenseTitle || expense.expense_title || 'Expense'}</strong>
                          {expense.note ? <small className="ffr-table-sub">{expense.note}</small> : null}
                        </td>
                        <td>
                          <div className="ffr-customer-cell">
                            <strong>{expense.paidToName || expense.paid_to_name || '-'}</strong>
                            <span>{expense.paidToMobile || expense.paid_to_mobile || '-'}</span>
                          </div>
                        </td>
                        <td>{formatMoney(getExpenseTotalAmount(expense))}</td>
                        <td className="green-text">{formatMoney(getExpensePaidAmount(expense))}</td>
                        <td className={due > 0 ? 'red-text' : 'green-text'}>{formatMoney(due)}</td>
                        <td>
                          <span className={`ffr-method-pill ${expense.paymentMethod || expense.payment_method || 'cash'}`}>
                            {expense.paymentMethod || expense.payment_method || 'cash'}
                          </span>
                        </td>
                        <td>
                          {getExpenseReceiptUrl(expense) ? (
                            <a
                              className="ffr-receipt-link"
                              href={getExpenseReceiptUrl(expense)}
                              target="_blank"
                              rel="noreferrer"
                            >
                              View
                            </a>
                          ) : (
                            <span className="ffr-muted-text">-</span>
                          )}
                        </td>
                        <td>
                          <span className={`ffr-status-pill ${status}`}>
                            {getExpensePaymentStatusLabel(status)}
                          </span>
                        </td>
                        <td>
                          <div className="ffr-expense-actions-row">
                            <button type="button" className="ffr-mini-outline-btn" onClick={() => editExpense(expense)}>Edit</button>
                            {due > 0 ? (
                              <button type="button" className="ffr-mini-pay-btn" onClick={() => openExpensePaymentBox(expense)}>Pay</button>
                            ) : null}
                            <button type="button" className="ffr-mini-outline-btn danger" onClick={() => deleteExpense(expense)}>Del</button>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          <div className="ffr-expense-mobile-list">
            {filteredExpenses.length === 0 ? (
              <div className="ffr-empty-box">No expense records found.</div>
            ) : (
              filteredExpenses.map((expense) => {
                const expenseId = expense.id || expense.expenseId;
                const category = expense.expenseCategory || expense.expense_category || 'other';
                const due = getExpenseDueAmount(expense);
                const status = getExpensePaymentStatus(expense);
                const receiptUrl = getExpenseReceiptUrl(expense);

                return (
                  <div key={`mobile_expense_${expenseId}`} className="ffr-expense-mobile-card">
                    <div className="ffr-expense-mobile-top">
                      <div>
                        <strong>{expense.expenseTitle || expense.expense_title || 'Expense'}</strong>
                        <span>{getExpenseCategoryIcon(category)} {getExpenseCategoryLabel(category)} • {formatDateOnly(expense.expenseDate || expense.expense_date)}</span>
                      </div>
                      <span className={`ffr-status-pill ${status}`}>{getExpensePaymentStatusLabel(status)}</span>
                    </div>

                    <div className="ffr-expense-mobile-meta">
                      <div>
                        <span>Total</span>
                        <strong>{formatMoney(getExpenseTotalAmount(expense))}</strong>
                      </div>
                      <div>
                        <span>Paid</span>
                        <strong className="green-text">{formatMoney(getExpensePaidAmount(expense))}</strong>
                      </div>
                      <div>
                        <span>Due</span>
                        <strong className={due > 0 ? 'red-text' : 'green-text'}>{formatMoney(due)}</strong>
                      </div>
                    </div>

                    <div className="ffr-expense-mobile-actions">
                      {receiptUrl ? (
                        <a className="ffr-expense-mini-btn receipt" href={receiptUrl} target="_blank" rel="noreferrer">Receipt</a>
                      ) : null}
                      <button type="button" className="ffr-expense-mini-btn edit" onClick={() => editExpense(expense)}>Edit</button>
                      {due > 0 ? (
                        <button type="button" className="ffr-expense-mini-btn pay" onClick={() => openExpensePaymentBox(expense)}>Pay</button>
                      ) : null}
                      <button type="button" className="ffr-expense-mini-btn delete" onClick={() => deleteExpense(expense)}>Delete</button>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
    );
  };

  const renderExpensePaymentModal = () => {
    if (!expensePaymentBox.open) return null;

    const expense = expensePaymentBox.expense;
    const due = getExpenseDueAmount(expense);
    const enteredAmount = toNumber(expensePaymentBox.amount, 0);

    return (
      <div className="ffr-modal-backdrop" onClick={expenseSaving ? undefined : closeExpensePaymentBox}>
        <div className="ffr-payment-modal" onClick={(e) => e.stopPropagation()}>
          <div className="ffr-panel-head">
            <div>
              <h2>Expense Payment</h2>
              <p>{expense?.expenseTitle || expense?.expense_title || 'Expense'}  due payment.</p>
            </div>

            <button type="button" className="ffr-view-btn" disabled={expenseSaving} onClick={closeExpensePaymentBox}>
              ✕
            </button>
          </div>

          <div className="ffr-payment-summary ffr-payment-summary-compact">
            <div>
              <span>Expense</span>
              <strong>{expense?.expenseTitle || expense?.expense_title || '-'}</strong>
            </div>
            <div>
              <span>Paid To</span>
              <strong>{expense?.paidToName || expense?.paid_to_name || '-'}</strong>
            </div>
            <div>
              <span>Total</span>
              <strong>{formatMoney(getExpenseTotalAmount(expense))}</strong>
            </div>
            <div>
              <span>Pending</span>
              <strong className="red-text">{formatMoney(due)}</strong>
            </div>
            <div>
              <span>After Payment</span>
              <strong className={due - enteredAmount > 0 ? 'red-text' : 'green-text'}>
                {formatMoney(Math.max(0, due - enteredAmount))}
              </strong>
            </div>
          </div>

          <div className="ffr-quick-amounts">
            <button type="button" disabled={expenseSaving} onClick={() => setExpensePaymentBox((prev) => ({ ...prev, amount: String(Math.ceil(due / 2)) }))}>
              Half
            </button>
            <button type="button" disabled={expenseSaving} onClick={() => setExpensePaymentBox((prev) => ({ ...prev, amount: String(due) }))}>
              Full Due
            </button>
            <button type="button" disabled={expenseSaving} onClick={() => setExpensePaymentBox((prev) => ({ ...prev, amount: '' }))}>
              Custom
            </button>
          </div>

          <div className="ffr-payment-form">
            <label>
              <span>Amount</span>
              <input
                type="number"
                min="0"
                max={due}
                value={expensePaymentBox.amount}
                disabled={expenseSaving}
                placeholder="Enter amount"
                onChange={(e) => setExpensePaymentBox((prev) => ({ ...prev, amount: e.target.value }))}
              />
            </label>

            <label>
              <span>Payment Method</span>
              <select
                value={expensePaymentBox.method}
                disabled={expenseSaving}
                onChange={(e) => setExpensePaymentBox((prev) => ({ ...prev, method: e.target.value }))}
              >
                {EXPENSE_PAYMENT_METHOD_OPTIONS.filter((item) => item.value !== 'credit').map((option) => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
              </select>
            </label>

            <label>
              <span>Reference No</span>
              <input
                type="text"
                value={expensePaymentBox.referenceNo}
                disabled={expenseSaving}
                placeholder="UPI / Transaction ref optional"
                onChange={(e) => setExpensePaymentBox((prev) => ({ ...prev, referenceNo: e.target.value }))}
              />
            </label>

            <label>
              <span>Note</span>
              <input
                type="text"
                value={expensePaymentBox.note}
                disabled={expenseSaving}
                placeholder="Payment note optional"
                onChange={(e) => setExpensePaymentBox((prev) => ({ ...prev, note: e.target.value }))}
              />
            </label>
          </div>

          <div className="ffr-selected-actions">
            <button type="button" disabled={expenseSaving} onClick={submitExpensePayment}>
              {expenseSaving ? 'Saving...' : 'Save Expense Payment'}
            </button>
            <button type="button" disabled={expenseSaving} onClick={closeExpensePaymentBox}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderPaymentModal = () => {
    if (!paymentBox.open) return null;

    const customer = paymentBox.customer;
    const bill = paymentBox.bill;

    const billDue = bill ? getBillRemainingDue(bill) : 0;
    const customerDue = getCustomerPayableDue(customer);
    const payableDue = bill ? billDue : customerDue;
    const enteredAmount = toNumber(paymentBox.amount, 0);

    return (
      <div className="ffr-modal-backdrop" onClick={savingPayment ? undefined : closePaymentBox}>
        <div className="ffr-payment-modal" onClick={(e) => e.stopPropagation()}>
          <div className="ffr-panel-head">
            <div>
              <h2>Collect Payment</h2>
              <p>
                {bill ? `${bill.billNo}  payment` : `${customer?.customerName || 'Customer'}  payment`}
              </p>
            </div>

            <button type="button" className="ffr-view-btn" disabled={savingPayment} onClick={closePaymentBox}>
              ✕
            </button>
          </div>

          <div className="ffr-payment-summary ffr-payment-summary-compact">
            <div>
              <span>Customer</span>
              <strong>{customer?.customerName || '-'}</strong>
            </div>

            <div>
              <span>Mobile</span>
              <strong>{customer?.customerMobile || '-'}</strong>
            </div>

            <div>
              <span>Bill</span>
              <strong>{bill?.billNo || 'All Pending'}</strong>
            </div>

            <div>
              <span>Pending</span>
              <strong className="red-text">{formatMoney(payableDue)}</strong>
            </div>

            <div>
              <span>After Payment</span>
              <strong className={payableDue - enteredAmount > 0 ? 'red-text' : 'green-text'}>
                {formatMoney(Math.max(0, payableDue - enteredAmount))}
              </strong>
            </div>

            <div>
              <span>Status</span>
              <strong>{enteredAmount >= payableDue && enteredAmount > 0 ? 'Full Paid' : 'Partial'}</strong>
            </div>
          </div>

          <div className="ffr-quick-amounts">
            <button
              type="button"
              disabled={savingPayment}
              onClick={() =>
                setPaymentBox((prev) => ({
                  ...prev,
                  type: 'partial',
                  amount: String(Math.ceil(payableDue / 2)),
                }))
              }
            >
              Half
            </button>

            <button
              type="button"
              disabled={savingPayment}
              onClick={() =>
                setPaymentBox((prev) => ({
                  ...prev,
                  type: 'full',
                  amount: String(payableDue),
                }))
              }
            >
              Full Due
            </button>

            <button
              type="button"
              disabled={savingPayment}
              onClick={() =>
                setPaymentBox((prev) => ({
                  ...prev,
                  type: 'partial',
                  amount: '',
                }))
              }
            >
              Custom
            </button>
          </div>

          <div className="ffr-payment-form">
            <label>
              <span>Amount</span>
              <input
                type="number"
                min="0"
                max={payableDue}
                value={paymentBox.amount}
                disabled={savingPayment}
                placeholder="Enter amount"
                onChange={(e) =>
                  setPaymentBox((prev) => ({
                    ...prev,
                    amount: e.target.value,
                    type: toNumber(e.target.value, 0) >= payableDue ? 'full' : 'partial',
                  }))
                }
              />
            </label>

            <label>
              <span>Payment Method</span>
              <select
                value={paymentBox.method}
                disabled={savingPayment}
                onChange={(e) =>
                  setPaymentBox((prev) => ({
                    ...prev,
                    method: e.target.value,
                  }))
                }
              >
                <option value="cash">Cash</option>
                <option value="upi">UPI</option>
                <option value="card">Card</option>
                <option value="online">Online</option>
                <option value="razorpay">Razorpay</option>
              </select>
            </label>

            <label>
              <span>Reference No</span>
              <input
                type="text"
                value={paymentBox.referenceNo}
                disabled={savingPayment}
                placeholder="UPI / Transaction ref optional"
                onChange={(e) =>
                  setPaymentBox((prev) => ({
                    ...prev,
                    referenceNo: e.target.value,
                  }))
                }
              />
            </label>

            <label>
              <span>Note</span>
              <input
                type="text"
                value={paymentBox.note}
                disabled={savingPayment}
                placeholder="Payment note optional"
                onChange={(e) =>
                  setPaymentBox((prev) => ({
                    ...prev,
                    note: e.target.value,
                  }))
                }
              />
            </label>
          </div>

          <div className="ffr-selected-actions">
            <button type="button" disabled={savingPayment} onClick={submitLocalPayment}>
              {savingPayment
                ? 'Saving...'
                : enteredAmount >= payableDue && enteredAmount > 0
                  ? 'Save Full Payment'
                  : 'Save Partial Payment'}
            </button>

            <button type="button" disabled={savingPayment} onClick={closePaymentBox}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderBillModal = () => {
    if (!billModalOpen || !selectedOrder) return null;

    return (
      <div className="ffr-modal-backdrop" onClick={() => setBillModalOpen(false)}>
        <div className="ffr-bill-modal" onClick={(e) => e.stopPropagation()}>
          <div className="ffr-panel-head">
            <div>
              <h2>{selectedOrder.billNo}</h2>
              <p>{formatDateTime(selectedOrder.recordDate)}</p>
            </div>

            <button type="button" className="ffr-view-btn" onClick={() => setBillModalOpen(false)}>
              ✕
            </button>
          </div>

          <div className="ffr-selected-info">
            <div>
              <span>Order No</span>
              <strong>{selectedOrder.orderNo}</strong>
            </div>

            <div>
              <span>Customer</span>
              <strong>{selectedOrder.customerName}</strong>
            </div>

            <div>
              <span>Mobile</span>
              <strong>{selectedOrder.customerMobile || '-'}</strong>
            </div>

            <div>
              <span>Mode</span>
              <strong>{getModeLabel(selectedOrder.displayMode)}</strong>
            </div>
          </div>

          <div className="ffr-table-wrap">
            <table className="ffr-record-table">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Qty</th>
                  <th>Rate</th>
                  <th>Total</th>
                </tr>
              </thead>

              <tbody>
                {(selectedOrder.productsParsed || []).length === 0 ? (
                  <tr>
                    <td colSpan="4" className="ffr-empty-cell">No items found.</td>
                  </tr>
                ) : (
                  selectedOrder.productsParsed.map((item, index) => {
                    const qty = toNumber(item?.quantity || item?.qty, 1);
                    const rate = toNumber(item?.price ?? item?.selling_price ?? item?.rate, 0);

                    return (
                      <tr key={`${item?.name}_${index}`}>
                        <td>{item?.name || item?.item_name || 'Item'}</td>
                        <td>{qty}</td>
                        <td>{formatMoney(rate)}</td>
                        <td>{formatMoney(qty * rate)}</td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          <div className="ffr-selected-money">
            <div>
              <span>Total</span>
              <strong>{formatMoney(selectedOrder.finalTotal)}</strong>
            </div>

            <div>
              <span>Paid</span>
              <strong className="green-text">{formatMoney(selectedOrder.amountPaid)}</strong>
            </div>

            <div>
              <span>Due</span>
              <strong className={selectedOrder.dueAmount > 0 ? 'red-text' : 'green-text'}>
                {formatMoney(selectedOrder.dueAmount)}
              </strong>
            </div>
          </div>

          <div className="ffr-selected-actions">
            <button type="button" onClick={printSelectedBill}>🖨 Print</button>
            <button type="button" onClick={() => setBillModalOpen(false)}>Close</button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Dashboard />

      <div className="page-below-navbar ffr-page-shell">
        <div className="ffr-container">
          <div className="ffr-topbar">
            <div>
              <div className="ffr-title-row">
                <span className="ffr-title-icon">🍔</span>

                <div>
                  <h1>Fast Food Records & Sales</h1>
                  <p>Bills, product sale aur customer khata sab ek jagah.</p>
                </div>
              </div>
            </div>

            <div className="ffr-top-actions">
              <div className="ffr-date-badge">📅 {dateRange.label}</div>

              <button type="button" className="ffr-white-btn" onClick={exportCsv}>
                ⬇ Export
              </button>

              <button type="button" className="ffr-primary-btn" onClick={refreshAllRecords}>
                ↻ Refresh
              </button>
            </div>
          </div>

          {message ? (
            <div className={`ffr-message ${messageType}`}>
              {message}
            </div>
          ) : null}

          {renderSectionTabs()}
          {renderSummaryCards()}
          {renderFilters()}

          {activeSection === 'bills' ? (
            <div className="ffr-main-grid" ref={billsRef}>
              <div className="ffr-left-content">
                {renderBillsTable()}
                {renderProductSalesSection()}
              </div>

              <div className="ffr-right-content">
                {renderSelectedBill()}
                {renderTopProducts()}
                {renderDueCustomersPanel()}
              </div>
            </div>
          ) : null}

          {activeSection === 'products' ? (
            <div className="ffr-single-section" ref={productsRef}>
              {renderProductSalesSection()}
              {renderTopProducts()}
            </div>
          ) : null}

          {activeSection === 'khata' ? renderCustomerKhataSection() : null}

          {activeSection === 'expenses' ? renderExpenseSection() : null}
        </div>
      </div>

      {renderBillModal()}
      {renderPaymentModal()}
      {renderExpensePaymentModal()}
    </>
  );
};

export default FastFoodRecords;
